export default __webpack_public_path__ + "static/media/le_touquet19.c5d2b344.jpg";